import { GlFilteredSearchToken, GlFilteredSearchSuggestion } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
import { getVerificationLevelOptions } from '../../constants';
export default {
    name: 'VerificationLevelToken',
    components: {
        GlFilteredSearchToken,
        GlFilteredSearchSuggestion
    },
    mixins: [
        glListenersMixin
    ],
    props: {
        config: {
            type: Object,
            required: true
        },
        value: {
            type: Object,
            required: true
        }
    },
    computed: {
        levels () {
            return getVerificationLevelOptions();
        }
    }
};
